/**
 * The files become the asset's materials: per file a title, a type and an audience (no default; who may see a file
 * is chosen on purpose), or **Leave out** to save without it. A left-out file is removed by the server's sweep.
 */

import { FileText } from 'lucide-react';

import { fromExtractionMaterialTitleMax } from '@/api/generated/schemas';

import { AudienceField, MaterialTypeField } from '../materials/MaterialFields';
import type { DraftMaterial } from './fromFilesDraft';

export function ReviewMaterials({
  materials,
  onChange,
}: {
  materials: DraftMaterial[];
  onChange: (fileId: string, patch: Partial<DraftMaterial>) => void;
}) {
  return (
    <section className="stack-md" aria-labelledby="review-materials-title">
      <h2 id="review-materials-title">Materials</h2>
      <p className="hint">Each file is kept as a material of the asset. Choose who may see it.</p>
      {materials.map((m) => {
        const id = `review-file-${m.file_id}`;
        return (
          <section key={m.file_id} className="card material-upload" aria-labelledby={`${id}-name`}>
            <div className="card-body stack-md">
              <div className="material-upload-head">
                <FileText aria-hidden="true" />
                <b id={`${id}-name`}>{m.filename}</b>
                <label className="check">
                  <input type="checkbox" checked={!m.include} onChange={(e) => onChange(m.file_id, { include: !e.target.checked })} />
                  <span className="ck-body">Leave out {m.filename}</span>
                </label>
              </div>
              {m.include && (
                <>
                  <div className="field">
                    <label htmlFor={`${id}-title`}>Title</label>
                    <input id={`${id}-title`} type="text" maxLength={fromExtractionMaterialTitleMax} value={m.title} onChange={(e) => onChange(m.file_id, { title: e.target.value })} />
                  </div>
                  <MaterialTypeField id={`${id}-type`} value={m.material_type} onChange={(material_type) => onChange(m.file_id, { material_type })} />
                  <AudienceField name={`${id}-audience`} value={m.audience} onChange={(audience) => onChange(m.file_id, { audience })} />
                </>
              )}
            </div>
          </section>
        );
      })}
    </section>
  );
}
